import { render, staticRenderFns } from "./sdproduct1.vue?vue&type=template&id=75202574&scoped=true"
import script from "./sdproduct1.vue?vue&type=script&lang=js"
export * from "./sdproduct1.vue?vue&type=script&lang=js"
import style0 from "./sdproduct1.vue?vue&type=style&index=0&id=75202574&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75202574",
  null
  
)

export default component.exports